import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./app/AuthContext";
import { ToastProvider } from "./app/Toast";
import { WashExecutionPage } from "./pages/WashExecution";
import "./styles/index.css";

const isWashExecutionRoute = /^\/wash-execution\/\d+\/?$/.test(window.location.pathname);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {isWashExecutionRoute ? (
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <Routes>
              <Route path="/wash-execution/:bookingId" element={<WashExecutionPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    ) : <App />}
  </React.StrictMode>,
);
